// extracted by mini-css-extract-plugin
export default {"wrapper":"NotifyUserOfOrder_wrapper__t3Cek","row":"NotifyUserOfOrder_row__pttqp","item":"NotifyUserOfOrder_item__6LrEy"};